/**
 * Art-medium overrides for Test Prompt V2 (must match backend StoryArtStyleV2 keys).
 */
export const ART_STYLE_OPTIONS = [
    { key: "none", label: "None (theme / prompt only)" },
    { key: "watercolor", label: "Watercolor" },
    { key: "oil_painting", label: "Oil painting" },
    { key: "acrylic", label: "Acrylic" },
    { key: "gouache", label: "Gouache" },
    { key: "pastel", label: "Pastel" },
    { key: "ink_wash", label: "Ink wash / sumi-e" },
    { key: "pencil_sketch", label: "Pencil sketch" },
    { key: "charcoal", label: "Charcoal" },
    { key: "surrealism", label: "Surrealism" },
    { key: "abstract", label: "Abstract" },
    { key: "impressionism", label: "Impressionism" },
    { key: "expressionism", label: "Expressionism" },
    { key: "cubism", label: "Cubism" },
    { key: "pop_art", label: "Pop art" },
    { key: "art_nouveau", label: "Art Nouveau" },
    { key: "art_deco", label: "Art Deco" },
    { key: "bauhaus", label: "Bauhaus" },
    { key: "minimalist", label: "Minimalist" },
    { key: "digital_illustration", label: "Digital illustration" },
    { key: "concept_art", label: "Concept art" },
    { key: "fantasy_illustration", label: "Fantasy illustration" },
    { key: "comic_book", label: "Comic book" },
    { key: "anime", label: "Anime / manga" },
    { key: "pixel_art", label: "Pixel art" },
    { key: "low_poly", label: "Low poly" },
    { key: "3d_render", label: "3D render" },
    { key: "photorealistic", label: "Photorealistic" },
    { key: "cinematic", label: "Cinematic" },
    { key: "stained_glass", label: "Stained glass" },
    { key: "mosaic", label: "Mosaic" },
    { key: "collage", label: "Collage" },
    { key: "paper_cut", label: "Paper cut" },
    { key: "linocut", label: "Linocut / woodcut" },
    { key: "vintage_poster", label: "Vintage poster" },
];

export function artStyleLabel(key) {
    const found = ART_STYLE_OPTIONS.find((o) => o.key === key);
    return found ? found.label : key || "none";
}
